import React, { useState, useRef, useEffect } from "react";
import "./styles/tableSearch.css";

const TableSearch = ({
  value,
  onChange,
  placeholder = "Search...",
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target) &&
        !value
      ) {
        setIsExpanded(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, [value]);

  const handleClear = (e) => {
    e.stopPropagation();
    onChange("");
    setIsExpanded(false);
  };

  return (
    <div
      className={`table-search-wrapper ${isExpanded ? "expanded" : ""}`}
      ref={wrapperRef}
      onClick={() => setIsExpanded(true)}
    >
      <span className="search-icon">
  <i className="fa-solid fa-magnifying-glass"></i>
</span>

      <input
        type="text"
        className="table-search-input"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setIsExpanded(true)}
      />

      {value && (
        <span className="clear-icon" onClick={handleClear}>
         <i className="fa-solid fa-xmark"></i>
        </span>
      )}
    </div>
  );
};

export default TableSearch;
